/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { SettingsGetConnectionQueryResponse, SettingsGetConnectionPathParams } from "../models/SettingsGetConnection";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { settingsGetConnection } from "../axios/settingsGetConnection";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const settingsGetConnectionQueryKey = (station: SettingsGetConnectionPathParams["station"], platform: SettingsGetConnectionPathParams["platform"]) => ["social-export-api", { url: '/connections/:station/:platform/settings', params: {station:station,platform:platform} }] as const

export type SettingsGetConnectionQueryKey = ReturnType<typeof settingsGetConnectionQueryKey>

export function settingsGetConnectionQueryOptions(station: SettingsGetConnectionPathParams["station"], platform: SettingsGetConnectionPathParams["platform"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = settingsGetConnectionQueryKey(station, platform)
        return queryOptions<SettingsGetConnectionQueryResponse, ResponseErrorConfig<Error>, SettingsGetConnectionQueryResponse, typeof queryKey>({
         enabled: !!(station&& platform),
         queryKey,
         queryFn: async ({ signal }) => {
            return settingsGetConnection(station, platform, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns the connection settings for a specific platform and station. If no connection exists, returns default settings.
 * @summary Get connection settings for a station
 * {@link /connections/:station/:platform/settings}
 */
export function useSettingsGetConnection<TData = SettingsGetConnectionQueryResponse, TQueryData = SettingsGetConnectionQueryResponse, TQueryKey extends QueryKey = SettingsGetConnectionQueryKey>(station: SettingsGetConnectionPathParams["station"], platform: SettingsGetConnectionPathParams["platform"], options: 
{
  query?: Partial<QueryObserverOptions<SettingsGetConnectionQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? settingsGetConnectionQueryKey(station, platform)
         

         const query = useQuery({
          ...settingsGetConnectionQueryOptions(station, platform, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}